




import { Component, Prop, Ref, Vue, Watch } from 'vue-property-decorator';
import { $tool } from '@/axios';
import { echarts, option } from './option';
import { IColorReadyData, IColorRawDetail } from './types';

// echarts 饼图
@Component
export default class ColorWheelPie extends Vue {
  @Prop() public width!: string | number;   // 图表画布宽度
  @Prop() public height!: string | number;  // 图表画布高度
  @Ref('pie-chart') public chartDom!: HTMLDivElement;

  public selectIndex = -1;                  // 已选中的数据索引
  public pieChart!: echarts.ECharts;        // echarts 饼图实例
  public colorList: IColorRawDetail[] = []; // 接口数据

  // 饼图的画布大小
  public get pieSizeStyle() {
    const width = parseInt(`${this.width}`, 10) || 300;
    const height = parseInt(`${this.height}`, 10) || 300;
    return { width: `${width}px`, height: `${height}px` };
  }

  // 在接口数据的基础上添加 hueIndex 和 sbIndex
  public get items() {
    // 色盘上的颜色
    const pieColors = this.colorList.slice(0, -1).map((item, i) => {
      const colorItem = { ...item.color, hue: i, sb: 0 };
      const colorList = item.color_list.map((sub, j) => ({ ...sub, hue: i, sb: j }));
      return { color: colorItem, color_list: colorList };
    });
    // 黑白灰4色
    const grayColors = this.colorList.slice(-1).map((item) => {
      const colorItem = { ...item.color, hue: -1, sb: 0 };
      const colorList = item.color_list.map((sub, j) => ({ ...sub, hue: -1, sb: j }));
      return { color: colorItem, color_list: colorList };
    });
    return { pieColors, grayColors };
  }

  // 饼图的数据集
  public get pieDataItems() {
    return this.items.pieColors.map((item) => ({
      value: 1,     // 每个扇形面积为圆形的 1/30
      raw: item,    // 保留源数据
      name: item.color.hue,
      itemStyle: { color: item.color.hex, borderColor: '#fff', borderWidth: 2 },
    }));
  }

  // 初始化查询颜色列表
  public async created() {
    try {
      const res: any = await $tool('color').post('/color-table');
      this.colorList = res.table || [];
    } catch (e) {
      this.colorList = [];
    }
  }

  // 初始化饼图配置(不含数据)
  public mounted() {
    this.pieChart = echarts.init(this.chartDom);
    this.pieChart.setOption(option);
    this.pieChart.on('selectchanged', this.onPieToggleSelect);
  }

  public beforeUnmount() {
    this.pieChart?.off('selectchanged', this.onPieToggleSelect);
  }

  // 取消选中(会触发 this.onPieToggleSelect)
  public unselect() {
    this.pieChart?.dispatchAction({ type: 'unselect', dataIndex: this.selectIndex });
  }

  // 饼图被选中或取消选中时
  // emit: select
  public onPieToggleSelect(e: any) {
    const i = e.selected[0]?.dataIndex[0];
    const rawData = this.pieDataItems[i]?.raw || null;
    this.selectIndex = typeof i === 'number' ? i : -1;
    this.$emit('select', rawData);
  }

  // 初始化饼图数据
  @Watch('pieDataItems', { immediate: true })
  public pieDataItemsChange(data: any[]) {
    this.$nextTick(() => {
      this.pieChart.setOption({ series: [{ data }] });
    });
  }

  // 数据准备完成后
  // emit: ready
  @Watch('items')
  public itemsChange(items: IColorReadyData) {
    if (!!items?.pieColors && !!items?.grayColors) {
      this.$emit('ready', items);
    }
  }
}
